import React, { useEffect, useState } from 'react';
import DictTagsService from '../../../services/dict/DictTagsService';
import { withTranslation } from 'react-i18next';
import Modal from '../../../constants/Modal';

type Props = {
    show: boolean;
    onClose: () => void;
    tagId: string;
    t: any;
};

const LanguageModal: React.FC<Props> = ({ show, onClose, tagId, t }) => {
    const [tagData, setTagData] = useState<any | null>(null);

    useEffect(() => {
        if (tagId) {
            DictTagsService.getDictTagsDetails(tagId)
                .then(response => {
                    setTagData(response.data);
                })
                .catch(error => {
                    console.error('Error fetching tag details:', error);
                });
        }
    }, [tagId]);

    const handleSave = (languageCode: string, newName: string) => {
        if (tagData) {
            const updatedData = {
                ...tagData,
                name: {
                    ...tagData.name,
                    [languageCode]: newName,
                }
            };
            setTagData(updatedData);
        }
    };

    const handleModalClose = () => {
        if (tagData) {
            DictTagsService.updateDictTagTranslations(tagData)
                .then(() => {
                    console.log('Tag updated successfully');
                })
                .catch((error: unknown) => {
                    console.error('Error updating tag:', error);
                });
        }
        onClose();
    };

    return (
        <Modal show={show} onClose={handleModalClose} title={t("tags.details")}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th>{t("table.language")}</th>
                        <th>{t("table.name")}</th>
                    </tr>
                </thead>
                <tbody>
                    {/* Render rows for each language */}
                </tbody>
            </table>
        </Modal>
    );
};

export default withTranslation("global")(LanguageModal);